export const addParamURL = (parameterName: string, parameter: string) => {
  const url = new URL(window.location as unknown as string);
  url.searchParams.set(parameterName, parameter);
  window.history.pushState({}, '', url);
};
